<template lang="pug">
Container(@loaded="afterload" :itemId="fileId")
    a-spin.office-view(v-if="!previewContent") 正在加载中...
    vue-office-docx(v-else :src="previewContent" 
        :options="{inWrapper: true}"
        style="height: calc(100vh - 0px);")
</template>

<script>
import Container from './Container.vue';
import VueOfficeDocx from '@vue-office/docx';
import '@vue-office/docx/lib/index.css';
import _ from 'lodash';
import axios from 'axios';
const host = '/api/fs';


export default {
    props: ['fileId'],
    data() {
        
        return {
            previewContent: null,

            id: '',
            name: '',
        }
    },
    mounted() {
        // this.load();
    },
    
    methods: {
        afterload(info) {
            this.id = info.id;
            this.name = info.name;
            

            this.load();
        },
        async load() {
            axios.get(`${host}/download/${this.id}`, {
                headers: {
                    'x-jwt': this.$api.jwt,
                },
                responseType: 'blob',
            }).then(res => {
                let fileReader = new FileReader();
                fileReader.readAsArrayBuffer(res.data);
                fileReader.onload = (e) => {
                    this.previewContent = e.target.result;
                };
            })
        }
    },
    
    components: {
        Container,
        VueOfficeDocx
    }
}
</script>

<style lang="less" scoped>

</style>
